import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  countryCode: {
    name: "countryCode",
    label: "Country Code",
    type: "text",
    errorMsg: "Country code is required.",
    required: true,
    //disabled: true,
    editable:false,
    maxLength: 10,
  },
  country: {
    name: "country",
    label: "Country",
    type: "text",
    errorMsg: "Country is required.",
    required: true,
    maxLength: 20,
  },
  currencyCode: {
    name: "currencyCode",
    label: "CurrencyCode",
    type: "text",
    maxLength: 10,
  }
};

const {
  countryCode,
  country,
  currencyCode
} = formField;

export const formRender = [
  [countryCode],
  [country],
  [currencyCode],
];

export const initialValues = getInitialValues(formField);

export const countryValidations = Yup.object().shape({
  [countryCode.name]: Yup.string().max(10).required(countryCode.errorMsg),
  [country.name]: Yup.string().max(20).required(country.errorMsg),
  [currencyCode.name]: Yup.string().max(10),
});
